import getRequest from '../../getRequest';

/**
 *
 * @param {number} currentPage
 * @param {number} itemsPerPage
 * @returns {AxiosResponse}s
 *
 */
const getDeployementDetails = (currentPage, itemsPerPage) => {
  const endpoint = `configuration-server/v1/deployment/Deployment-Logs?page=${currentPage}&size=${itemsPerPage}`;

  return new Promise((resolve, reject) => {
    getRequest(endpoint, 'Deployement details')
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export default getDeployementDetails;
